(function ($) {
    let $components = $(".comp_rooms");

    if (!$components.length) {
        return;
    }

    $components.each(function () {
        const $component = $(this);
        const headerText = $component.find("[data-target=\"headerText\"]")[0];
        const $headerSeeMoreButton = $component.find("[data-click=\"headerSeeMore\"]");

        if (!headerText || headerText.clientHeight >= headerText.scrollHeight) {
            if (headerText) {
                headerText.style.webkitLineClamp = "none";
            }
            $headerSeeMoreButton.parent().remove();
            return;
        }

        $headerSeeMoreButton.on("click", function (e) {
            e.preventDefault();

            $(this).parent().slideUp(300, function () {
                $(this).remove();
            });

            headerText.style.height = headerText.clientHeight + "px";
            headerText.style.webkitLineClamp = "none";

            const animation = headerText.animate({
                height: headerText.scrollHeight + "px"
            }, {
                duration: 300,
                easing: "ease-in-out",
            })

            animation.onfinish = function() {
                headerText.style.height = null;
            };
        });
    });
})(jQuery);
